import { axios } from 'Lib/axios'
import { ExtractFnReturnType, QueryConfig } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { DetailedViewRequest } from '../routes/Home/utils'
import { useQuery } from '@tanstack/react-query'
import { Filters, RowsResponse } from '../routes/Home/types'

export const getUserInsights = async (
  payload: DetailedViewRequest
): Promise<RowsResponse | Error> => {
  return axios
    .post<{ data: RowsResponse }>(
      `/users/${payload.userId}/accounts/${payload.accountId}/dashboard/detailed-view`,
      payload
    )
    .then((result) => result.data.data)
}

type QueryFnTypeDetailedView = typeof getUserInsights

type detailedViewDefaultParams = Filters & { config?: QueryConfig<QueryFnTypeDetailedView> }

export const useGetUserInsights = (defaultParams: detailedViewDefaultParams) => {
  const { accountId, userId, owner } = useUserStore()
  const params: DetailedViewRequest = {
    accountId,
    userId,
    ...defaultParams,
  }
  const userParams = owner ? { ...params, domains: [] } : params
  const query = useQuery<ExtractFnReturnType<QueryFnTypeDetailedView>>({
    queryKey: [
      'getUserInsights',
      params.accountId,
      params.startDate,
      params.endDate,
      params.page,
      params.keyword,
      params.column,
      params.order,
      params.pageType,
      params.campaigns,
      params.domains,
      params.countries,
      params.threatGroups,
      params.threatTypes,
    ],
    queryFn: () => getUserInsights(userParams),
    ...defaultParams.config,
    enabled: defaultParams.domains && defaultParams.domains.length > 0,
  })

  const data = query.data instanceof Error ? undefined : query.data?.data

  return { ...query, data }
}
